module.exports = __webpack_public_path__ + "static/media/drone.761c44c6.svg";